import { GainValues } from '../components/common/constants';
import { IAudiogramResponse, IOption } from '../models/product-detail';

export const starkeyChoiceHook = (
    gainOptions: IOption,
    right: IAudiogramResponse | null,
    left: IAudiogramResponse | null,
    rightIds: number[],
    leftIds: number[]
) => {
    gainOptions.items.forEach((y) => {
        if (right && right.matrix) {
            if (y.english.split('/')[1] === `${right.matrix.gain}`) {
                if (!rightIds.includes(y.id)) rightIds.push(y.id);
            } else {
                if (rightIds.includes(y.id))
                    rightIds.splice(rightIds.indexOf(y.id), 1);
            }
            if (!y.english.includes('/')) {
                GainValues.forEach((gain) => {
                    if (y.english === gain.text) {
                        //not sure why the compiler thinks right and right matrix could be null here
                        if (right && right.matrix) {
                            if (gain.value === `${right.matrix.gain}`) {
                                if (!rightIds.includes(y.id))
                                    rightIds.push(y.id);
                            } else {
                                if (rightIds.includes(y.id))
                                    rightIds.splice(rightIds.indexOf(y.id), 1);
                            }
                        }
                    }
                });
            }
        }
        if (left && left.matrix) {
            if (y.english.split('/')[1] === `${left.matrix.gain}`) {
                if (!leftIds.includes(y.id)) leftIds.push(y.id);
            } else {
                if (leftIds.includes(y.id))
                    leftIds.splice(leftIds.indexOf(y.id), 1);
            }
            if (!y.english.includes('/')) {
                GainValues.forEach((gain) => {
                    if (y.english === gain.text) {
                        if (left && left.matrix) {
                            if (gain.value === `${left.matrix.gain}`) {
                                if (!leftIds.includes(y.id)) leftIds.push(y.id);
                            } else {
                                if (leftIds.includes(y.id))
                                    leftIds.splice(leftIds.indexOf(y.id), 1);
                            }
                        }
                    }
                });
            }
        }
    });
    return { rightIds, leftIds };
};
